// Mock data (identical content to original elorte-medaric.ba)

export const company = {
  name: "Elorte-Medarić",
  legal: "Elorte-Medarić d.o.o.",
  tagline: "PVC elektro ormari za godine koje su pred Vama",
  descriptionShort:
    "Proizvodnja i projektovanje KPMO, KPO i GRMO ormara od najkvalitetnijih, specijaliziranih, te vakumiranih PVC ploča njemačkog proizvođača Kömmerling.",
  descriptionLong:
    "Svi ormari mogu biti i opremljeni prema uputstvima nadležnih Elektrodistribucija.",
  address: "Rosulje br. 77, 74264 Jelah, BiH",
  hours: "Ponedjeljak – Petak, 08:00 – 16:00h",
  emails: ["info@elorte-medaric.ba", "contact@elorte-medaric.ba"],
  phone: "+387 61 993 481",
  facebook:
    "https://www.facebook.com/Elorte-Medari%C4%87-doo-103210988623238/?ref=py_c",
};

export const stats = [
  { value: "IP54", label: "Stepen zaštite" },
  { value: "3-4mm", label: "Debljina PVC ploča" },
  { value: "100%", label: "Njemački Kömmerling" },
];

export const advantages = [
  {
    title: "Otpornost na atmosferske uticaje",
    desc: "Ormari podnose sve vremenske prilike – sunce, kišu, snijeg i mraz bez gubitka svojstava.",
    icon: "CloudSun",
  },
  {
    title: "Nisu podložni koroziji",
    desc: "Za razliku od metalnih ormara, PVC ne rđa niti se kvari s vremenom.",
    icon: "Shield",
  },
  {
    title: "Jednostavna montaža",
    desc: "Lagana konstrukcija i pametan dizajn omogućavaju brzu i sigurnu ugradnju.",
    icon: "Wrench",
  },
  {
    title: "Samogasiva PVC plastika",
    desc: "Materijal CPT-OVO klase samogasivosti pruža vrhunsku sigurnost od požara.",
    icon: "Flame",
  },
  {
    title: "Dvostruka izolacija",
    desc: "Zaštita od dodira dijelova pod naponom izvedena sistemom dvostruke izolacije.",
    icon: "Zap",
  },
  {
    title: "IP54 zaštita",
    desc: "Prozori od stakla debljine 3 mm sa PVC gumenim brtvenim okvirom.",
    icon: "Lock",
  },
];

export const products = [
  {
    slug: "kpmo",
    name: "Kućni priključno-mjerni ormarić",
    short: "KPMO",
    description:
      "Ormarić sa osigurač-sklopkama i brojilom koji se nalazi na prijelazu iz distribucijske u privatnu elektroenergetsku mrežu.",
    image:
      "https://i0.wp.com/www.elorte-medaric.ba/wp-content/uploads/2022/03/KPMO.jpg?fit=607%2C493&ssl=1",
    features: ["Sa brojilom", "Osigurač-sklopke", "IP54", "Dvostruka izolacija"],
  },
  {
    slug: "kpo",
    name: "Kućni priključni ormarić",
    short: "KPO",
    description:
      "Namijenjen je za priključivanje na električnu mrežu tamo gdje nije neophodno da se, uz glavne osigurače, nalazi i mjerna garnitura.",
    image:
      "https://i0.wp.com/www.elorte-medaric.ba/wp-content/uploads/2022/03/KPO.jpg?fit=408%2C381&ssl=1",
    features: ["Glavni osigurači", "Bez brojila", "Otporan na UV", "Samogasiv"],
  },
  {
    slug: "opp",
    name: "Ormarić prve pomoći",
    short: "OPP",
    description:
      "Namijenjeni su za pohranu i čuvanje seta za pružanje prve pomoći. U ponudi su ormarići za prvu pomoć u nadžbuk izvedbi.",
    image:
      "https://i0.wp.com/www.elorte-medaric.ba/wp-content/uploads/2022/03/OPP.jpg?fit=474%2C545&ssl=1",
    features: ["Nadžbuk izvedba", "Set prve pomoći", "Standard EU", "Lako čišćenje"],
  },
  {
    slug: "grmo",
    name: "Kućni razdjelnici sa vratima",
    short: "GRMO",
    description:
      "Kućni razdjelnici sa vratima za sigurnu raspodjelu električne energije unutar objekta – idealni za stanove i poslovne prostore.",
    image:
      "https://images.pexels.com/photos/28265032/pexels-photo-28265032.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Sa vratima", "Više modula", "Zaključavanje", "Prilagodljivo"],
  },
];

export const heroImage =
  "https://images.pexels.com/photos/30144993/pexels-photo-30144993.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const workshopImage =
  "https://images.pexels.com/photos/34718922/pexels-photo-34718922.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const qualityImage =
  "https://images.pexels.com/photos/14804687/pexels-photo-14804687.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const marqueeItems = [
  "KPMO",
  "KPO",
  "GRMO",
  "IP54",
  "Kömmerling PVC",
  "CPT-OVO 3–4 mm",
  "Samogasivo",
  "Dvostruka izolacija",
  "ATEST",
  "Made in BiH",
];

export const atest = {
  title: "Atest – Certifikat kvaliteta",
  subtitle: "Svi naši proizvodi posjeduju atest izdat od strane ovlaštene ustanove.",
  description:
    "Svaki ormar proizveden u Elorte-Medarić d.o.o. prošao je stroge laboratorijske testove i posjeduje važeći atest – dokument koji potvrđuje usklađenost sa svim važećim standardima električne sigurnosti i tehničkim uslovima nadležnih Elektrodistribucija u Bosni i Hercegovini.",
  items: [
    { code: "IP54", title: "Stepen zaštite IP54", desc: "Zaštita od prašine i prskanja vode sa svih strana – testirano i potvrđeno." },
    { code: "CPT-OVO", title: "Samogasivost PVC-a", desc: "Materijal CPT-OVO klase samogasivosti potvrđen atestom njemačkog Kömmerling-a." },
    { code: "II", title: "Dvostruka izolacija", desc: "Sistem dvostruke električne izolacije prema međunarodnim IEC standardima." },
    { code: "ED", title: "Usklađenost sa Elektrodistribucijom", desc: "Ormari izrađeni prema uputstvima i tehničkim uslovima nadležnih Elektrodistribucija." },
  ],
  points: [
    "Važeći atest izdat od ZIK d.o.o. Mostar",
    "EU izjava o sukladnosti (CE)",
    "Testovi mehaničke i električne otpornosti",
    "Usklađenost sa BAS EN IEC 61439 / 62208",
    "Dokumentacija dostupna online",
  ],
};
